// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__1npvn","footer":"ModalUpdate_footer__2Fss_"};